import { SfIconsNames } from './sfIconNames';

export const SfIconDescriptions: Record<SfIconsNames, string> = {
  [SfIconsNames.AccountInfo]: 'Account Info',
  [SfIconsNames.AccountScore]: 'Account Score',
  [SfIconsNames.Account]: 'Account',
  [SfIconsNames.ActionListComponent]: 'Action List Component',
  [SfIconsNames.ActionsAndButtons]: 'Actions and Buttons',
  [SfIconsNames.ActivationTarget]: 'Activation Target',
  [SfIconsNames.Activations]: 'Activations',
  [SfIconsNames.AdEventAction]: 'Ad Event Action',
  [SfIconsNames.AdEventCause]: 'Ad Event Cause',
  [SfIconsNames.AdEventEffect]: 'Ad Event Effect',
  [SfIconsNames.AdEventFactor]: 'Ad Event Factor',
  [SfIconsNames.AdEventInfo]: 'Ad Event Info',
  [SfIconsNames.AdEventOutcome]: 'Ad Event Outcome',
  [SfIconsNames.AdEventParty]: 'Ad Event Party',
  [SfIconsNames.Address]: 'Address',
  [SfIconsNames.AdverseEvent]: 'Adverse Event',
  [SfIconsNames.AgentHome]: 'Agent Home',
  [SfIconsNames.AgentSession]: 'Agent Session',
  [SfIconsNames.Aggregate]: 'Aggregate',
  [SfIconsNames.AggregationPolicy]: 'Aggregation Policy',
  [SfIconsNames.AiAcceleratorCard]: 'AI Accelerator Card',
  [SfIconsNames.All]: 'All',
  [SfIconsNames.Announcement]: 'Announcement',
  [SfIconsNames.AnswerBest]: 'Answer Best',
  [SfIconsNames.AnswerPrivate]: 'Answer Private',
  [SfIconsNames.AnswerPublic]: 'Answer Public',
  [SfIconsNames.AppFormProductParticipant]: 'App Form Product Participant',
  [SfIconsNames.Approval]: 'Approval',
  [SfIconsNames.AppsAdmin]: 'Apps Admin',
  [SfIconsNames.Apps]: 'Apps',
  [SfIconsNames.Article]: 'Article',
  [SfIconsNames.AssetActionSource]: 'Asset Action Source',
  [SfIconsNames.AssetAction]: 'Asset Action',
  [SfIconsNames.AssetAudit]: 'Asset Audit',
  [SfIconsNames.AssetDowntimePeriod]: 'Asset Downtime Period',
  [SfIconsNames.AssetHierarchy]: 'Asset Hierarchy',
  [SfIconsNames.AssetObject]: 'Asset Object',
  [SfIconsNames.AssetRelationship]: 'Asset Relationship',
  [SfIconsNames.AssetStatePeriod]: 'Asset State Period',
  [SfIconsNames.AssetWarranty]: 'Asset Warranty',
  [SfIconsNames.AssignedResource]: 'Assigned Resource',
  [SfIconsNames.Assignment]: 'Assignment',
  [SfIconsNames.Attach]: 'Attach',
  [SfIconsNames.AttributeBasedPricing]: 'Attribute Based Pricing',
  [SfIconsNames.AvatarLoading]: 'Avatar Loading',
  [SfIconsNames.Avatar]: 'Avatar',
  [SfIconsNames.BillOfMaterials]: 'Bill of Materials',
  [SfIconsNames.Billing]: 'Billing',
  [SfIconsNames.BotTraining]: 'Bot Training',
  [SfIconsNames.Bot]: 'Bot',
  [SfIconsNames.BranchMerge]: 'Branch Merge',
  [SfIconsNames.Brand]: 'Brand',
  [SfIconsNames.BudgetAllocation]: 'Budget Allocation',
  [SfIconsNames.BudgetCategoryValue]: 'Budget Category Value',
  [SfIconsNames.BudgetPeriod]: 'Budget Period',
  [SfIconsNames.Budget]: 'Budget',
  [SfIconsNames.BundleConfig]: 'Bundle Config',
  [SfIconsNames.BundlePolicy]: 'Bundle Policy',
  [SfIconsNames.BundlesPricing]: 'Bundles Pricing',
  [SfIconsNames.BusinessHours]: 'Business Hours',
  [SfIconsNames.BuyerAccount]: 'Buyer Account',
  [SfIconsNames.BuyerGroupQualifier]: 'Buyer Group Qualifier',
  [SfIconsNames.BuyerGroup]: 'Buyer Group',
  [SfIconsNames.CalculatedDimension]: 'Calculated Dimension',
  [SfIconsNames.CalculatedInsights]: 'Calculated Insights',
  [SfIconsNames.CalculatedMeasure]: 'Calculated Measure',
  [SfIconsNames.Calibration]: 'Calibration',
  [SfIconsNames.CallCoaching]: 'Call Coaching',
  [SfIconsNames.CallHistory]: 'Call History',
  [SfIconsNames.Call]: 'Call',
  [SfIconsNames.CampaignMembers]: 'Campaign Members',
  [SfIconsNames.Campaign]: 'Campaign',
  [SfIconsNames.Canvas]: 'Canvas',
  [SfIconsNames.CapacityPlan]: 'Capacity Plan',
  [SfIconsNames.CareRequestReviewer]: 'Care Request Reviewer',
  [SfIconsNames.Carousel]: 'Carousel',
  [SfIconsNames.CodePlayground]: 'Code Playground',
  [SfIconsNames.CodeSetBundle]: 'Code Set Bundle',
  [SfIconsNames.CodeSet]: 'Code Set',
  [SfIconsNames.CollectionVariable]: 'Collection Variable',
  [SfIconsNames.Collection]: 'Collection',
  [SfIconsNames.ConnectWallet]: 'Connect Wallet',
  [SfIconsNames.ConnectedApps]: 'Connected Apps',
  [SfIconsNames.Constant]: 'Constant',
  [SfIconsNames.ContactList]: 'Contact List',
  [SfIconsNames.ContactRequest]: 'Contact Request',
  [SfIconsNames.Contact]: 'Contact',
  [SfIconsNames.ContractLineItem]: 'Contract Line Item',
  [SfIconsNames.ContractLineOutcomeData]: 'Contract Line Outcome Data',
  [SfIconsNames.ContractLineOutcome]: 'Contract Line Outcome',
  [SfIconsNames.ContractPayment]: 'Contract Payment',
  [SfIconsNames.Contract]: 'Contract',
  [SfIconsNames.CostModel]: 'Cost Model',
  [SfIconsNames.CouponCodes]: 'Coupon Codes',
  [SfIconsNames.CryptoCategoryWalletGroup]: 'Crypto Category Wallet Group',
  [SfIconsNames.CryptoProductCategoryWalletRole]: 'Crypto Product Category Wallet Role',
  [SfIconsNames.CryptoProduct]: 'Crypto Product',
  [SfIconsNames.CryptoTransactionEnvelopeChangeSnapshot]:
    'Crypto Transaction Envelope Change Snapshot',
  [SfIconsNames.CryptoTransactionEnvelopeItem]: 'Crypto Transaction Envelope Item',
  [SfIconsNames.CryptoTransactionEnvelope]: 'Crypto Transaction Envelope',
  [SfIconsNames.CryptoTransaction]: 'Crypto Transaction',
  [SfIconsNames.CryptoWalletGroupItem]: 'Crypto Wallet Group Item',
  [SfIconsNames.CryptoWalletGroup]: 'Crypto Wallet Group',
  [SfIconsNames.CryptoWallet]: 'Crypto Wallet',
  [SfIconsNames.CurrencyInput]: 'Currency Input',
  [SfIconsNames.Currency]: 'Currency',
  [SfIconsNames.CustodyChainEntry]: 'Custody Chain Entry',
  [SfIconsNames.CustodyEntryVerification]: 'Custody Entry Verification',
  [SfIconsNames.CustodyOverride]: 'Custody Override',
  [SfIconsNames.CustomComponentTask]: 'Custom Component Task',
  [SfIconsNames.CustomNotification]: 'Custom Notification',
  [SfIconsNames.Custom]: 'Custom',
  [SfIconsNames.Customer360]: 'Customer 360',
  [SfIconsNames.CustomerLifecycleAnalytics]: 'Customer Lifecycle Analytics',
  [SfIconsNames.CustomerPortalUsers]: 'Customer Portal Users',
  [SfIconsNames.CustomerWorkspace]: 'Customer Workspace',
  [SfIconsNames.Customer]: 'Customer',
  [SfIconsNames.Customers]: 'Customers',
  [SfIconsNames.DashboardComponent]: 'Dashboard Component',
  [SfIconsNames.DashboardEa]: 'Dashboard EA',
  [SfIconsNames.Dashboard]: 'Dashboard',
  [SfIconsNames.DataCloud]: 'Data Cloud',
  [SfIconsNames.DataGovernance]: 'Data Governance',
  [SfIconsNames.DataGraph]: 'Data Graph',
  [SfIconsNames.DataIntegrationHub]: 'Data Integration Hub',
  [SfIconsNames.DataLakeObjects]: 'Data Lake Objects',
  [SfIconsNames.DataMapping]: 'Data Mapping',
  [SfIconsNames.DataModel]: 'Data Model',
  [SfIconsNames.DataStreams]: 'Data Streams',
  [SfIconsNames.DataTransforms]: 'Data Transforms',
  [SfIconsNames.Datadotcom]: 'Datadotcom',
  [SfIconsNames.Dataset]: 'Dataset',
  [SfIconsNames.DatashareTarget]: 'Datashare Target',
  [SfIconsNames.Datashares]: 'Datashares',
  [SfIconsNames.DateInput]: 'Date Input',
  [SfIconsNames.DateTime]: 'Date Time',
  [SfIconsNames.Decision]: 'Decision',
  [SfIconsNames.Default]: 'Default',
  [SfIconsNames.DelegatedAccount]: 'Delegated Account',
  [SfIconsNames.Device]: 'Device',
  [SfIconsNames.DigitalVerificationConfigGroup]: 'Digital Verification Config Group',
  [SfIconsNames.DigitalVerificationConfig]: 'Digital Verification Config',
  [SfIconsNames.DisclosureAndCompliance]: 'Disclosure and Compliance',
  [SfIconsNames.Discounts]: 'Discounts',
  [SfIconsNames.DiseaseDefinitionCriteria]: 'Disease Definition Criteria',
  [SfIconsNames.DiseaseInvestigation]: 'Disease Investigation',
  [SfIconsNames.DiseaseOutbreak]: 'Disease Outbreak',
  [SfIconsNames.DisplayRichText]: 'Display Rich Text',
  [SfIconsNames.DisplayText]: 'Display Text',
  [SfIconsNames.DocumentPreview]: 'Document Preview',
  [SfIconsNames.DocumentReference]: 'Document Reference',
  [SfIconsNames.Document]: 'Document',
  [SfIconsNames.Drafts]: 'Drafts',
  [SfIconsNames.DurationDownscale]: 'Duration Downscale',
  [SfIconsNames.DynamicHighlightsPanel]: 'Dynamic Highlights Panel',
  [SfIconsNames.DynamicRecordChoice]: 'Dynamic Record Choice',
  [SfIconsNames.EditForm]: 'Edit Form',
  [SfIconsNames.Education]: 'Education',
  [SfIconsNames.EinsteinReplies]: 'Einstein Replies',
  [SfIconsNames.EmailChatter]: 'Email Chatter',
  [SfIconsNames.Email]: 'Email',
  [SfIconsNames.EmployeeAsset]: 'Employee Asset',
  [SfIconsNames.EmployeeContact]: 'Employee Contact',
  [SfIconsNames.EmployeeJobPosition]: 'Employee Job Position',
  [SfIconsNames.EmployeeJob]: 'Employee Job',
  [SfIconsNames.EmployeeOrganization]: 'Employee Organization',
  [SfIconsNames.Employee]: 'Employee',
  [SfIconsNames.Empty]: 'Empty',
  [SfIconsNames.Endorsement]: 'Endorsement',
  [SfIconsNames.EnrolleeStatus]: 'Enrollee Status',
  [SfIconsNames.EntitlementPolicy]: 'Entitlement Policy',
  [SfIconsNames.EntitlementProcess]: 'Entitlement Process',
  [SfIconsNames.EntitlementTemplate]: 'Entitlement Template',
  [SfIconsNames.Entitlement]: 'Entitlement',
  [SfIconsNames.EntityMilestone]: 'Entity Milestone',
  [SfIconsNames.Entity]: 'Entity',
  [SfIconsNames.EnvironmentHub]: 'Environment Hub',
  [SfIconsNames.EvalResult]: 'Eval Result',
  [SfIconsNames.EventExt]: 'Event Ext',
  [SfIconsNames.Event]: 'Event',
  [SfIconsNames.Events]: 'Events',
  [SfIconsNames.ExpenseReportEntry]: 'Expense Report Entry',
  [SfIconsNames.ExpenseReport]: 'Expense Report',
  [SfIconsNames.Expense]: 'Expense',
  [SfIconsNames.FacilityBed]: 'Facility Bed',
  [SfIconsNames.Feed]: 'Feed',
  [SfIconsNames.Feedback]: 'Feedback',
  [SfIconsNames.FieldSales]: 'Field Sales',
  [SfIconsNames.File]: 'File',
  [SfIconsNames.FilterCriteriaRule]: 'Filter Criteria Rule',
  [SfIconsNames.FilterCriteria]: 'Filter Criteria',
  [SfIconsNames.Filter]: 'Filter',
  [SfIconsNames.FirstNonEmpty]: 'First Non Empty',
  [SfIconsNames.Flow]: 'Flow',
  [SfIconsNames.Folder]: 'Folder',
  [SfIconsNames.Forecasts]: 'Forecasts',
  [SfIconsNames.Form]: 'Form',
  [SfIconsNames.Formula]: 'Formula',
  [SfIconsNames.FulfillmentOrder]: 'Fulfillment Order',
  [SfIconsNames.FundingAwardAdjustment]: 'Funding Award Adjustment',
  [SfIconsNames.FundingRequirement]: 'Funding Requirement',
  [SfIconsNames.GenericLoading]: 'Generic Loading',
  [SfIconsNames.GlobalConstant]: 'Global Constant',
  [SfIconsNames.Goals]: 'Goals',
  [SfIconsNames.GroupLoading]: 'Group Loading',
  [SfIconsNames.Groups]: 'Groups',
  [SfIconsNames.GuidanceCenter]: 'Guidance Center',
  [SfIconsNames.HeaderDiscounts]: 'Header Discounts',
  [SfIconsNames.Hierarchy]: 'Hierarchy',
  [SfIconsNames.HighVelocitySales]: 'High Velocity Sales',
  [SfIconsNames.HistoricalAdherence]: 'Historical Adherence',
  [SfIconsNames.HolidayOperatingHours]: 'Holiday Operating Hours',
  [SfIconsNames.Home]: 'Home',
  [SfIconsNames.Household]: 'Household',
  [SfIconsNames.Identifier]: 'Identifier',
  [SfIconsNames.Immunization]: 'Immunization',
  [SfIconsNames.ImpactOutcome]: 'Impact Outcome',
  [SfIconsNames.ImpactStrategyAssignment]: 'Impact Strategy Assignment',
  [SfIconsNames.ImpactStrategy]: 'Impact Strategy',
  [SfIconsNames.Inbox]: 'Inbox',
  [SfIconsNames.Incident]: 'Incident',
  [SfIconsNames.IndicatorAssignment]: 'Indicator Assignment',
  [SfIconsNames.IndicatorDefinition]: 'Indicator Definition',
  [SfIconsNames.IndicatorPerformancePeriod]: 'Indicator Performance Period',
  [SfIconsNames.IndicatorResult]: 'Indicator Result',
  [SfIconsNames.Individual]: 'Individual',
  [SfIconsNames.Insights]: 'Insights',
  [SfIconsNames.InstoreLocations]: 'Instore Locations',
  [SfIconsNames.InvestmentAccount]: 'Investment Account',
  [SfIconsNames.InvocableAction]: 'Invocable Action',
  [SfIconsNames.IotContext]: 'Iot Context',
  [SfIconsNames.IotOrchestrations]: 'Iot Orchestrations',
  [SfIconsNames.JavascriptButton]: 'Javascript Button',
  [SfIconsNames.JobFamily]: 'Job Family',
  [SfIconsNames.JobPosition]: 'Job Position',
  [SfIconsNames.JobProfile]: 'Job Profile',
  [SfIconsNames.Kanban]: 'Kanban',
  [SfIconsNames.KeyDates]: 'Key Dates',
  [SfIconsNames.Knowledge]: 'Knowledge',
  [SfIconsNames.Labels]: 'Labels',
  [SfIconsNames.LeadInsights]: 'Lead Insights',
  [SfIconsNames.LeadList]: 'Lead List',
  [SfIconsNames.Lead]: 'Lead',
  [SfIconsNames.LearnerProgram]: 'Learner Program',
  [SfIconsNames.Letterhead]: 'Letterhead',
  [SfIconsNames.LifeSciences]: 'Life Sciences',
  [SfIconsNames.LightningComponent]: 'Lightning Component',
  [SfIconsNames.LightningUsage]: 'Lightning Usage',
  [SfIconsNames.Link]: 'Link',
  [SfIconsNames.Linked]: 'Linked',
  [SfIconsNames.ListEmail]: 'List Email',
  [SfIconsNames.ListFee]: 'List Fee',
  [SfIconsNames.ListRate]: 'List Rate',
  [SfIconsNames.LiveChatVisitor]: 'Live Chat Visitor',
  [SfIconsNames.LiveChat]: 'Live Chat',
  [SfIconsNames.LocationPermit]: 'Location Permit',
  [SfIconsNames.Location]: 'Location',
  [SfIconsNames.LogACall]: 'Log a Call',
  [SfIconsNames.Logging]: 'Logging',
  [SfIconsNames.Loop]: 'Loop',
  [SfIconsNames.Macros]: 'Macros',
  [SfIconsNames.MaintenanceAsset]: 'Maintenance Asset',
  [SfIconsNames.MaintenancePlan]: 'Maintenance Plan',
  [SfIconsNames.MaintenanceWorkRule]: 'Maintenance Work Rule',
  [SfIconsNames.ManualDiscounts]: 'Manual Discounts',
  [SfIconsNames.MapLineItem]: 'Map Line Item',
  [SfIconsNames.Market]: 'Market',
  [SfIconsNames.MarketingActions]: 'Marketing Actions',
  [SfIconsNames.MedRecStatementRecommendation]: 'Med Rec Statement Recommendation',
  [SfIconsNames.MedicationAdministration]: 'Medication Administration',
  [SfIconsNames.MedicationDispense]: 'Medication Dispense',
  [SfIconsNames.MedicationIngredient]: 'Medication Ingredient',
  [SfIconsNames.MedicationReconciliation]: 'Medication Reconciliation',
  [SfIconsNames.MedicationStatement]: 'Medication Statement',
  [SfIconsNames.Medication]: 'Medication',
  [SfIconsNames.MemberPeriod]: 'Member Period',
  [SfIconsNames.Merge]: 'Merge',
  [SfIconsNames.MessagingConversation]: 'Messaging Conversation',
  [SfIconsNames.MessagingSession]: 'Messaging Session',
  [SfIconsNames.MessagingUser]: 'Messaging User',
  [SfIconsNames.MetricDefinition]: 'Metric Definition',
  [SfIconsNames.Metric]: 'Metric',
  [SfIconsNames.Metrics]: 'Metrics',
  [SfIconsNames.Mulesoft]: 'Mulesoft',
  [SfIconsNames.MultiPicklist]: 'Multi Picklist',
  [SfIconsNames.MultiSelectCheckbox]: 'Multi Select Checkbox',
  [SfIconsNames.NetworkContract]: 'Network Contract',
  [SfIconsNames.News]: 'News',
  [SfIconsNames.NftSettings]: 'Nft Settings',
  [SfIconsNames.NftStudio]: 'Nft Studio',
  [SfIconsNames.NoCodeModel]: 'No Code Model',
  [SfIconsNames.Note]: 'Note',
  [SfIconsNames.NumberInput]: 'Number Input',
  [SfIconsNames.ObservationComponent]: 'Observation Component',
  [SfIconsNames.OmniChannel]: 'Omni Channel',
  [SfIconsNames.OmniSupervisor]: 'Omni Supervisor',
  [SfIconsNames.OperatingHours]: 'Operating Hours',
  [SfIconsNames.OperationPlanExecution]: 'Operation Plan Execution',
  [SfIconsNames.OperationPlanRequest]: 'Operation Plan Request',
  [SfIconsNames.OperationPlanStepExecution]: 'Operation Plan Step Execution',
  [SfIconsNames.OperationPlanStep]: 'Operation Plan Step',
  [SfIconsNames.OperationPlan]: 'Operation Plan',
  [SfIconsNames.OpportunityContactRole]: 'Opportunity Contact Role',
  [SfIconsNames.OpportunitySplits]: 'Opportunity Splits',
  [SfIconsNames.Opportunity]: 'Opportunity',
  [SfIconsNames.Orchestrator]: 'Orchestrator',
  [SfIconsNames.OrderItem]: 'Order Item',
  [SfIconsNames.Orders]: 'Orders',
  [SfIconsNames.OutcomeActivity]: 'Outcome Activity',
  [SfIconsNames.Outcome]: 'Outcome',
  [SfIconsNames.Output]: 'Output',
  [SfIconsNames.PanelDetail]: 'Panel Detail',
  [SfIconsNames.PartnerFundAllocation]: 'Partner Fund Allocation',
  [SfIconsNames.PartnerFundClaim]: 'Partner Fund Claim',
  [SfIconsNames.PartnerFundRequest]: 'Partner Fund Request',
  [SfIconsNames.PartnerMarketingBudget]: 'Partner Marketing Budget',
  [SfIconsNames.Partners]: 'Partners',
  [SfIconsNames.PartyProfile]: 'Party Profile',
  [SfIconsNames.Password]: 'Password',
  [SfIconsNames.PastChat]: 'Past Chat',
  [SfIconsNames.PathExperiment]: 'Path Experiment',
  [SfIconsNames.PatientMedicationDosage]: 'Patient Medication Dosage',
  [SfIconsNames.PatientService]: 'Patient Service',
  [SfIconsNames.PaymentGateway]: 'Payment Gateway',
  [SfIconsNames.PeopleScore]: 'People Score',
  [SfIconsNames.People]: 'People',
  [SfIconsNames.Performance]: 'Performance',
  [SfIconsNames.PersonAccount]: 'Person Account',
  [SfIconsNames.PersonLanguage]: 'Person Language',
  [SfIconsNames.PersonName]: 'Person Name',
  [SfIconsNames.Photo]: 'Photo',
  [SfIconsNames.PicklistChoice]: 'Picklist Choice',
  [SfIconsNames.PicklistType]: 'Picklist Type',
  [SfIconsNames.Planogram]: 'Planogram',
  [SfIconsNames.Policy]: 'Policy',
  [SfIconsNames.Poll]: 'Poll',
  [SfIconsNames.PortalRolesAndSubordinates]: 'Portal Roles and Subordinates',
  [SfIconsNames.PortalRoles]: 'Portal Roles',
  [SfIconsNames.Portal]: 'Portal',
  [SfIconsNames.Post]: 'Post',
  [SfIconsNames.PractitionerRole]: 'Practitioner Role',
  [SfIconsNames.PrepFlow]: 'Prep Flow',
  [SfIconsNames.PriceAdjustmentMatrix]: 'Price Adjustment Matrix',
  [SfIconsNames.PriceAdjustmentSchedule]: 'Price Adjustment Schedule',
  [SfIconsNames.PriceAdjustmentTier]: 'Price Adjustment Tier',
  [SfIconsNames.PriceBookEntries]: 'Price Book Entries',
  [SfIconsNames.PriceBooks]: 'Price Books',
  [SfIconsNames.PriceSheet]: 'Price Sheet',
  [SfIconsNames.Pricebook]: 'Pricebook',
  [SfIconsNames.PricingWorkspace]: 'Pricing Workspace',
  [SfIconsNames.Problem]: 'Problem',
  [SfIconsNames.ProcedureDetail]: 'Procedure Detail',
  [SfIconsNames.ProcedureOutputResolution]: 'Procedure Output Resolution',
  [SfIconsNames.Procedure]: 'Procedure',
  [SfIconsNames.ProcessException]: 'Process Exception',
  [SfIconsNames.Process]: 'Process',
  [SfIconsNames.ProductConsumedState]: 'Product Consumed State',
  [SfIconsNames.ProductConsumed]: 'Product Consumed',
  [SfIconsNames.ProductItemTransaction]: 'Product Item Transaction',
  [SfIconsNames.ProductItem]: 'Product Item',
  [SfIconsNames.ProductQuantityRules]: 'Product Quantity Rules',
  [SfIconsNames.ProductRequestLineItem]: 'Product Request Line Item',
  [SfIconsNames.ProductRequest]: 'Product Request',
  [SfIconsNames.ProductRequired]: 'Product Required',
  [SfIconsNames.ProductServiceCampaignItem]: 'Product Service Campaign Item',
  [SfIconsNames.ProductServiceCampaign]: 'Product Service Campaign',
  [SfIconsNames.ProductTransferState]: 'Product Transfer State',
  [SfIconsNames.ProductTransfer]: 'Product Transfer',
  [SfIconsNames.ProductWarrantyTerm]: 'Product Warranty Term',
  [SfIconsNames.ProductWorkspace]: 'Product Workspace',
  [SfIconsNames.Product]: 'Product',
  [SfIconsNames.Products]: 'Products',
  [SfIconsNames.ProgramCohortMember]: 'Program Cohort Member',
  [SfIconsNames.ProgramCohort]: 'Program Cohort',
  [SfIconsNames.ProgramDetail]: 'Program Detail',
  [SfIconsNames.ProgramSite]: 'Program Site',
  [SfIconsNames.ProgramStatus]: 'Program Status',
  [SfIconsNames.PromotionSegments]: 'Promotion Segments',
  [SfIconsNames.PromotionTiers]: 'Promotion Tiers',
  [SfIconsNames.PromotionsWorkspace]: 'Promotions Workspace',
  [SfIconsNames.Promotions]: 'Promotions',
  [SfIconsNames.PromptBuilder]: 'Prompt Builder',
  [SfIconsNames.Prompt]: 'Prompt',
  [SfIconsNames.PropagationPolicy]: 'Propagation Policy',
  [SfIconsNames.Proposition]: 'Proposition',
  [SfIconsNames.Prospect]: 'Prospect',
  [SfIconsNames.Qualifications]: 'Qualifications',
  [SfIconsNames.QueryEditor]: 'Query Editor',
  [SfIconsNames.QuestionBest]: 'Question Best',
  [SfIconsNames.QuestionFeed]: 'Question Feed',
  [SfIconsNames.Queue]: 'Queue',
  [SfIconsNames.QuickText]: 'Quick Text',
  [SfIconsNames.QuipSheet]: 'Quip Sheet',
  [SfIconsNames.Quip]: 'Quip',
  [SfIconsNames.Quotes]: 'Quotes',
  [SfIconsNames.RadioButton]: 'Radio Button',
  [SfIconsNames.RateAdjustment]: 'Rate Adjustment',
  [SfIconsNames.ReadReceipts]: 'Read Receipts',
  [SfIconsNames.RealTime]: 'Real Time',
  [SfIconsNames.Recent]: 'Recent',
  [SfIconsNames.Recipe]: 'Recipe',
  [SfIconsNames.RecordConsent]: 'Record Consent',
  [SfIconsNames.RecordCreate]: 'Record Create',
  [SfIconsNames.RecordDelete]: 'Record Delete',
  [SfIconsNames.RecordLookup]: 'Record Lookup',
  [SfIconsNames.RecordSignatureTask]: 'Record Signature Task',
  [SfIconsNames.RecordUpdate]: 'Record Update',
  [SfIconsNames.Record]: 'Record',
  [SfIconsNames.RecycleBin]: 'Recycle Bin',
  [SfIconsNames.RegisteredModel]: 'Registered Model',
  [SfIconsNames.RelatedList]: 'Related List',
  [SfIconsNames.Relationship]: 'Relationship',
  [SfIconsNames.Repeaters]: 'Repeaters',
  [SfIconsNames.Replace]: 'Replace',
  [SfIconsNames.ReplyText]: 'Reply Text',
  [SfIconsNames.ReportType]: 'Report Type',
  [SfIconsNames.Report]: 'Report',
  [SfIconsNames.ResetPassword]: 'Reset Password',
  [SfIconsNames.ResourceAbsence]: 'Resource Absence',
  [SfIconsNames.ResourceCapacity]: 'Resource Capacity',
  [SfIconsNames.ResourcePreference]: 'Resource Preference',
  [SfIconsNames.ResourceSkill]: 'Resource Skill',
  [SfIconsNames.RestrictionPolicy]: 'Restriction Policy',
  [SfIconsNames.ReturnOrderLineItem]: 'Return Order Line Item',
  [SfIconsNames.ReturnOrder]: 'Return Order',
  [SfIconsNames.Reward]: 'Reward',
  [SfIconsNames.Robot]: 'Robot',
  [SfIconsNames.RtcPresence]: 'Rtc Presence',
  [SfIconsNames.SalesCadenceTarget]: 'Sales Cadence Target',
  [SfIconsNames.SalesCadence]: 'Sales Cadence',
  [SfIconsNames.SalesChannel]: 'Sales Channel',
  [SfIconsNames.SalesPath]: 'Sales Path',
  [SfIconsNames.SalesValue]: 'Sales Value',
  [SfIconsNames.SalesforceCms]: 'Salesforce Cms',
  [SfIconsNames.ScanCard]: 'Scan Card',
  [SfIconsNames.ScheduleObjective]: 'Schedule Objective',
  [SfIconsNames.SchedulingConstraint]: 'Scheduling Constraint',
  [SfIconsNames.SchedulingPolicy]: 'Scheduling Policy',
  [SfIconsNames.SchedulingWorkspaceTerritory]: 'Scheduling Workspace Territory',
  [SfIconsNames.SchedulingWorkspace]: 'Scheduling Workspace',
  [SfIconsNames.Screen]: 'Screen',
  [SfIconsNames.Search]: 'Search',
  [SfIconsNames.Section]: 'Section',
  [SfIconsNames.Segments]: 'Segments',
  [SfIconsNames.SellingModel]: 'Selling Model',
  [SfIconsNames.SendLog]: 'Send Log',
  [SfIconsNames.SerializedProductTransaction]: 'Serialized Product Transaction',
  [SfIconsNames.SerializedProduct]: 'Serialized Product',
  [SfIconsNames.ServiceAppointmentCapacityUsage]: 'Service Appointment Capacity Usage',
  [SfIconsNames.ServiceAppointment]: 'Service Appointment',
  [SfIconsNames.ServiceContract]: 'Service Contract',
  [SfIconsNames.ServiceCrewMember]: 'Service Crew Member',
  [SfIconsNames.ServiceCrew]: 'Service Crew',
  [SfIconsNames.ServiceReport]: 'Service Report',
  [SfIconsNames.ServiceRequestDetail]: 'Service Request Detail',
  [SfIconsNames.ServiceRequest]: 'Service Request',
  [SfIconsNames.ServiceResource]: 'Service Resource',
  [SfIconsNames.ServiceTerritoryLocation]: 'Service Territory Location',
  [SfIconsNames.ServiceTerritoryMember]: 'Service Territory Member',
  [SfIconsNames.ServiceTerritoryPolicy]: 'Service Territory Policy',
  [SfIconsNames.ServiceTerritory]: 'Service Territory',
  [SfIconsNames.Settings]: 'Settings',
  [SfIconsNames.SetupModal]: 'Setup Modal',
  [SfIconsNames.ShiftPatternEntry]: 'Shift Pattern Entry',
  [SfIconsNames.ShiftPattern]: 'Shift Pattern',
  [SfIconsNames.ShiftPreference]: 'Shift Preference',
  [SfIconsNames.ShiftSchedulingOperation]: 'Shift Scheduling Operation',
  [SfIconsNames.ShiftTemplate]: 'Shift Template',
  [SfIconsNames.ShiftType]: 'Shift Type',
  [SfIconsNames.Shift]: 'Shift',
  [SfIconsNames.Shipment]: 'Shipment',
  [SfIconsNames.SkillEntity]: 'Skill Entity',
  [SfIconsNames.SkillRequirement]: 'Skill Requirement',
  [SfIconsNames.Skill]: 'Skill',
  [SfIconsNames.SlackConversations]: 'Slack Conversations',
  [SfIconsNames.Slack]: 'Slack',
  [SfIconsNames.Slider]: 'Slider',
  [SfIconsNames.Sms]: 'Sms',
  [SfIconsNames.SnippetAlt]: 'Snippet Alt',
  [SfIconsNames.Snippet]: 'Snippet',
  [SfIconsNames.Snippets]: 'Snippets',
  [SfIconsNames.SobjectCollection]: 'Sobject Collection',
  [SfIconsNames.Sobject]: 'Sobject',
  [SfIconsNames.Social]: 'Social',
  [SfIconsNames.Solution]: 'Solution',
  [SfIconsNames.SortPolicy]: 'Sort Policy',
  [SfIconsNames.Sort]: 'Sort',
  [SfIconsNames.Sossession]: 'Sossession',
  [SfIconsNames.StageCollection]: 'Stage Collection',
  [SfIconsNames.Stage]: 'Stage',
  [SfIconsNames.Steps]: 'Steps',
  [SfIconsNames.StoreGroup]: 'Store Group',
  [SfIconsNames.Store]: 'Store',
  [SfIconsNames.Story]: 'Story',
  [SfIconsNames.Strategy]: 'Strategy',
  [SfIconsNames.StudyCandidate]: 'Study Candidate',
  [SfIconsNames.StudyRelated]: 'Study Related',
  [SfIconsNames.Study]: 'Study',
  [SfIconsNames.SubMetric]: 'Sub Metric',
  [SfIconsNames.SummaryLiable]: 'Summary Liable',
  [SfIconsNames.SummaryUsage]: 'Summary Usage',
  [SfIconsNames.Survey]: 'Survey',
  [SfIconsNames.SwarmRequest]: 'Swarm Request',
  [SfIconsNames.SwarmSession]: 'Swarm Session',
  [SfIconsNames.SystemAndGlobalVariable]: 'System and Global Variable',
  [SfIconsNames.Table]: 'Table',
  [SfIconsNames.Tableau]: 'Tableau',
  [SfIconsNames.Task]: 'Task',
  [SfIconsNames.Task2]: 'Task2',
  [SfIconsNames.TaxPolicy]: 'Tax Policy',
  [SfIconsNames.TaxRate]: 'Tax Rate',
  [SfIconsNames.TaxTreatment]: 'Tax Treatment',
  [SfIconsNames.Taxonomy]: 'Taxonomy',
  [SfIconsNames.TeamMember]: 'Team Member',
  [SfIconsNames.Template]: 'Template',
  [SfIconsNames.TextTemplate]: 'Text Template',
  [SfIconsNames.Text]: 'Text',
  [SfIconsNames.Textarea]: 'Textarea',
  [SfIconsNames.Textbox]: 'Textbox',
  [SfIconsNames.ThanksLoading]: 'Thanks Loading',
  [SfIconsNames.Thanks]: 'Thanks',
  [SfIconsNames.TimePeriod]: 'Time Period',
  [SfIconsNames.TimesheetEntry]: 'Timesheet Entry',
  [SfIconsNames.Timesheet]: 'Timesheet',
  [SfIconsNames.Timeslot]: 'Timeslot',
  [SfIconsNames.TitleParty]: 'Title Party',
  [SfIconsNames.Today]: 'Today',
  [SfIconsNames.Toggle]: 'Toggle',
  [SfIconsNames.Topic]: 'Topic',
  [SfIconsNames.Topic2]: 'Topic2',
  [SfIconsNames.TourCheck]: 'Tour Check',
  [SfIconsNames.Tour]: 'Tour',
  [SfIconsNames.TrailheadAlt]: 'Trailhead Alt',
  [SfIconsNames.Trailhead]: 'Trailhead',
  [SfIconsNames.TransactionUsageEntitlement]: 'Transaction Usage Entitlement',
  [SfIconsNames.TravelMode]: 'Travel Mode',
  [SfIconsNames.UnifiedHealthScore]: 'Unified Health Score',
  [SfIconsNames.Unmatched]: 'Unmatched',
  [SfIconsNames.UploadedModel]: 'Uploaded Model',
  [SfIconsNames.UsageEntitlementAccount]: 'Usage Entitlement Account',
  [SfIconsNames.UsageEntitlementBucket]: 'Usage Entitlement Bucket',
  [SfIconsNames.UsageEntitlementEntry]: 'Usage Entitlement Entry',
  [SfIconsNames.UsageRateableSummary]: 'Usage Rateable Summary',
  [SfIconsNames.UserRole]: 'User Role',
  [SfIconsNames.User]: 'User',
  [SfIconsNames.Variable]: 'Variable',
  [SfIconsNames.VariationAttributeSetup]: 'Variation Attribute Setup',
  [SfIconsNames.VariationProducts]: 'Variation Products',
  [SfIconsNames.Video]: 'Video',
  [SfIconsNames.VisitTemplates]: 'Visit Templates',
  [SfIconsNames.Visits]: 'Visits',
  [SfIconsNames.VisualforcePage]: 'Visualforce Page',
  [SfIconsNames.Visualization]: 'Visualization',
  [SfIconsNames.VoiceCall]: 'Voice Call',
  [SfIconsNames.VolumeDiscounts]: 'Volume Discounts',
  [SfIconsNames.Waits]: 'Waits',
  [SfIconsNames.Walkthroughs]: 'Walkthroughs',
  [SfIconsNames.WarrantyTerm]: 'Warranty Term',
  [SfIconsNames.Water]: 'Water',
  [SfIconsNames.Webcart]: 'Webcart',
  [SfIconsNames.Whatsapp]: 'Whatsapp',
  [SfIconsNames.WorkCapacityLimit]: 'Work Capacity Limit',
  [SfIconsNames.WorkCapacityUsage]: 'Work Capacity Usage',
  [SfIconsNames.WorkContract]: 'Work Contract',
  [SfIconsNames.WorkForecast]: 'Work Forecast',
  [SfIconsNames.WorkOrderItem]: 'Work Order Item',
  [SfIconsNames.WorkOrder]: 'Work Order',
  [SfIconsNames.WorkPlanRule]: 'Work Plan Rule',
  [SfIconsNames.WorkPlanTemplateEntry]: 'Work Plan Template Entry',
  [SfIconsNames.WorkPlanTemplate]: 'Work Plan Template',
  [SfIconsNames.WorkPlan]: 'Work Plan',
  [SfIconsNames.WorkQueue]: 'Work Queue',
  [SfIconsNames.WorkStepTemplate]: 'Work Step Template',
  [SfIconsNames.WorkStep]: 'Work Step',
  [SfIconsNames.WorkSummary]: 'Work Summary',
  [SfIconsNames.WorkTypeGroup]: 'Work Type Group',
  [SfIconsNames.WorkType]: 'Work Type',
  [SfIconsNames.WorkforceEngagement]: 'Workforce Engagement',
  [SfIconsNames.Workspace]: 'Workspace',
  [SfIconsNames.YourAccount]: 'Your Account',
  [SfIconsNames.MedRecRecommendation]: 'Med Rec Recommendation',
};
